import React, { useEffect } from "react";
import "./LibraryChapter.css";
import { useState } from "react";
import axios from "../../../../axios";
export default function EditNotePopup({
  handleCloseNoteEditPopup,
  data,
  userData,
  contentId,
  setComponentRerenderFlag,
  setNotesInput,
  setNotesAttachment,
  setAttachment2,
  setNotesAttachmentId,
}) {
  const [noteText, setNoteText] = useState(data?.notesText);
  const [attachments, setAttachments] = useState(data?.noteFileInfo);
  const [idsArray, setIdsArray] = useState([]);
  useEffect(() => {
    const extractedIds = attachments.map((obj) => obj.id);
    setIdsArray(extractedIds);
  }, [attachments]);
  const handleremove = (indexToRemove) => {
    if (indexToRemove >= 0 && indexToRemove < attachments.length) {
      const updatedAttachments = [...attachments];
      const updatedAttachments1 = [...idsArray];
      updatedAttachments.splice(indexToRemove, 1);
      updatedAttachments1.splice(indexToRemove, 1);
      setAttachments(updatedAttachments);
      setIdsArray(updatedAttachments1);
    }
  };
  const handleUpdateNotes = async () => {
    let body = {
      user_id: userData?.id,
      contentInfo_id: contentId,
      note_id: data?.id,
      noteNewText: noteText,
      newfileInfoId: idsArray,
    };
    let res = await axios.post(
      `/cm/library/book/updateUserNotesByUserIDAndContentInfoID`,
      body
    );
    if (res.status === 200) {
      // window.location.reload();
      setComponentRerenderFlag((prevFlag) => !prevFlag);
      setNotesInput("");
      setNotesAttachment([]);
      setAttachment2([]);
      setNotesAttachmentId([]);
    }
  };
  const handleAttachment = async (files) => {
    let fileSelected = [...attachments];
    if (files) {
      for (const file of files) {
        try {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          if (!allowedTypes.includes(file.type)) {
            window.alert(
              "Invalid file type. Only PDF, JPEG, PNG, MP3, and MP4 files are allowed."
            );
            continue;
          }
          const maxSizeInMB = file.type.startsWith("image")
            ? 5
            : file.type === "audio/mpeg"
              ? 50
              : 250;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
          if (file.type === "application/pdf" && file.size > 50 * 1024 * 1024) {
            window.alert("PDF file size exceeds 50 MB.");
            continue;
          } else if (file.size > maxSizeInBytes) {
            window.alert(`File size exceeds ${maxSizeInMB} MB.`);
            continue;
          }
          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("content", file);
          let res1 = await axios.post(
            `/school/library/uploadFile?module_name=studentNotes`,
            formData
          );
          res1 && fileSelected.push(res1.data.data);
          console.log(fileSelected);
        } catch (error) {
          console.log(error);
        }
      }
      setAttachments(fileSelected);
    }
  };
  return (
    <div>
      <div className="ContainerDeletePop">
        <div className="SubContainerDeletePop ">
          <div>
            <img
              className="crossIcon"
              src="/DCM-img/crossIcon.svg"
              alt="Up Arrow"
              onClick={() => {
                handleCloseNoteEditPopup();
              }}
            />
          </div>
          <div className="text-xl font-bold">Edit Note</div>
          <div className="lastUpdateDate mt-1">Last Updated 20 hours ago</div>
          <textarea
            className="teaxtAreaNote mt-3"
            value={noteText}
            onChange={(e) => {
              setNoteText(e.target.value);
            }}
          ></textarea>
          <div className="d-flex justify-content-between mt-3">
            <div className="d-flex gap-2 ">
              <div className="mr-2 pt-1">
                <input
                  onChange={(e) => {
                    handleAttachment(e.target.files);
                  }}
                  multiple
                  type="file"
                  id="attachFile1"
                  style={{ display: "none" }}
                />
                {/* <label htmlFor="attachFile1">
                  <img
                    style={{ cursor: "pointer" }}
                    src="/LibraryImg/Attachment.png"
                    alt="Attachment icon"
                  />{" "}
                  &nbsp;
                  <span className="attachfileText">Attach File</span>
                </label> */}
              </div>
              <div className="d-flex gap-2 align-items-center">
                {attachments.length > 0 &&
                  attachments.map((obj, index) => (
                    <>
                      <div>
                        <img src="/LibraryImg/JpgIcon.png" alt="" />
                      </div>
                      <div className="UplodedimgName">{obj?.fileName}</div>
                      <div className="ml-2">
                        <img
                          src="/LibraryImg/CrossPdf.png"
                          alt=""
                          onClick={() => {
                            handleremove(index);
                          }}
                        />
                      </div>
                    </>
                  ))}
              </div>
            </div>
            <div>
              <button
                className="postEditNoteBtn"
                onClick={() => {
                  handleUpdateNotes();
                  handleCloseNoteEditPopup()
                }}
              >
                Post
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
